module.exports = __webpack_public_path__ + "static/media/Menu.5ed81d50.svg";